import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the CSI result page (CSIResult -> CSICoachingReport).
// Mirrors that layout: action buttons, greeting, overall card, the two summary
// cards, and the per-area breakdown. Matches the app's other page skeletons
// (see CoachingSkeleton) instead of a spinner.
export default function CSIResultSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-4xl mx-auto px-4 py-6 md:py-8">
                    {/* action buttons (Download PDF / Retake) */}
                    <div className="flex justify-end gap-2 mb-4">
                        <Skeleton width={140} height={38} borderRadius={12} />
                        <Skeleton width={110} height={38} borderRadius={12} />
                    </div>

                    <div className="space-y-6">
                        {/* greeting */}
                        <div>
                            <Skeleton width={220} height={28} />
                            <Skeleton width="70%" height={14} className="mt-2" />
                        </div>

                        {/* overall summary card */}
                        <div className={`${cardCls} p-5 md:p-6`}>
                            <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                                <div className="shrink-0">
                                    <Skeleton width={80} height={40} />
                                    <Skeleton width={70} height={22} borderRadius={999} className="mt-2" />
                                </div>
                                <div className="flex-1">
                                    <Skeleton width="60%" height={20} />
                                    <Skeleton count={2} className="mt-1" />
                                </div>
                            </div>
                        </div>

                        {/* two summary cards (strengths / focus) */}
                        {[0, 1].map(i => (
                            <div key={i} className={`${cardCls} p-5`}>
                                <Skeleton width="45%" height={18} className="mb-3" />
                                <Skeleton width="30%" height={15} />
                                <Skeleton count={2} />
                            </div>
                        ))}

                        {/* per-area breakdown */}
                        <div>
                            <Skeleton width="45%" height={18} className="mb-3" />
                            <div className="space-y-3">
                                {[0, 1, 2, 3, 4].map(i => (
                                    <div key={i} className={`${cardCls} p-4`}>
                                        <div className="flex items-center justify-between gap-3 mb-2">
                                            <Skeleton width="35%" height={16} />
                                            <Skeleton width={70} height={22} borderRadius={999} />
                                        </div>
                                        <Skeleton height={8} borderRadius={999} className="mb-3" />
                                        <Skeleton count={1} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
